/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import axios from "@/http/customsAxios";
import http from "@/http";
import * as types from "./types";

import { customCheckerboardData } from '@/data/modelsData';

const actions = {
  async [types.GET_UGC_SWATCH]({ rootState, dispatch }, { model, imageBuffer, checkerboardCombination, componentName, size = '5.0 Boys = 6.5 Women' }) {
    const { pdm } = rootState.utils;
    const pdmPlacements = pdm.components[componentName].ugc.placements;
    const placementName = rootState.translations.data[`ugcPlacement1RefInstructions-${componentName}`];
    let placements;

    const requestUrl = `${rootState.endPoints.customcheckerboard.ugcPlacementImage}`;

    return axios({
      url: requestUrl,
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      data: JSON.stringify({
        componentName,
        productName: model,
        tonalstitch: '1',
        size,
        placementBuffer: [ { placementName, imageBuffer } ]
      })
    })
    .then(({ data }) => {
      placements = pdmPlacements.map((item, idx) => {
        const placementData = { ...data[0] };
        if (idx == 1) {
          delete placementData.tonal_stitch_color;
        }
        return placementData;
      });

      return dispatch('ugc/GET_UGC_SWATCH', {
          componentName,
          productName: model,
          placements,
          size,
          endpointsType: 'customcheckerboard'
        } , { root: true })
      })
      .then(({ data }) => {
        const { tonal_stitch_color } =  placements[0];
        const { size : sizeCanvas , warp } = rootState.customCheckerboard.canvasConfig;
        const imageId = checkerboardCombination[sizeCanvas][warp].imageId;
        const ugcTemp = {
          original_image: { image_id: imageId, image_url: `${rootState.endPoints.customcheckerboard.ugcImageFolder}${imageId}.png`},
          ugc_swatch: data,
          placements,
          size,
          tonal_stitch_color
        };

        return { ugcTemp };
      })
      .catch(console.error);
  },

  [types.UPLOAD](context, { inputFile }) {
    const data = new FormData();
    data.append("file-input", inputFile, "image.jpg");

    const requestUrl = `${context.rootState.endPoints.customcheckerboard.ugc}`;

    return new Promise((resolve, reject) => {
      http
        .post(requestUrl, data)
        .then(({ data }) => resolve(data))
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },
  [types.FETCH_PRODUCT_DATA](context, { availableModels }) {
    if (availableModels && availableModels.length > 0) {
      const data = {};
      let modelData;
      availableModels.forEach(modelName => {
        modelData = customCheckerboardData[modelName];
        if (!!modelData) {
          data[modelName] = modelData;
        }
      });
      return Promise.resolve(data);
    }
    return Promise.resolve(customCheckerboardData);
  },
  [types.GET_PDM]({ commit }, { pdmModel }) {
    const requestUrl = `${this.state.endPoints.customcheckerboard.pdm}${pdmModel}.json`;

    return http.get(requestUrl).then(({ data }) => {
      commit('utils/SET_PDM', data, { root: true });
      return data;
    })
  },
  [types.GET_CHECKERBOARD_SIZE]({ commit }) {
    const requestUrl = `${this.state.endPoints.customcheckerboard.customsAssets}/json/customCheckerboard.json`;
    return http.get(requestUrl).then(({ data }) => {
      commit(types.SET_CHECKERBOARD_SIZE, data);
    })
  },
};

export default actions;
